import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    getCountryCode,
    getEmail,
    getUserInvesteeId,
    getPhoneNumber,
    getPhoneVerifiedState,
    getEmailVerifiedState,
    getIfUserIsInvestee,
    getInvesteeSidebarConfigTab,
    getWidgetData,
} from '../../../App/AppReducer';
import { basePathInvestee, generateRequestId, showNotification } from '../../../../util/utility';
import '../Authentication/Signup.css';
import './VerifyEmailPage.scss';
import {
    fetchUserProfile,
    resendVerifyUserEmail,
    updateInvestProfileInfo,
} from '../../../App/AppActions';
import { API_STATUS, SHOW_NOTIFICATION_STATUS } from '../../../../enums/appEnums';
import { sendOtpHelper, setWhatsappPreference, validateOtpHelper } from '../../common/apiHelpers';
import { WhatsappPreference } from '../../common/models/Login';
import { isEmpty, isNil } from 'lodash';
import storage from '../../../../util/storageService';

function VerifyEmailPhone(props: any) {
    const [otps, setOtps] = useState({
        otp1: '',
        otp2: '',
        otp3: '',
        otp4: '',
        otp5: '',
        otp6: '',
    });
    const location = useLocation();
    const state: any = location.state;
    const [isEmailVerified, setIsEmailVerified] = useState(
        useSelector((state) => getEmailVerifiedState(state)) ??
            state?.isEmailVerified ??
            props.isEmailVerified,
    );
    const [isdisabled, setIsDisabled] = useState(true);
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [phoneVerified, setPhoneVerified] = useState(
        useSelector((state) => getPhoneVerifiedState(state)),
    );
    const emailId = useSelector((state) => getEmail(state)) ?? state?.emailId;
    const investeeId = useSelector((state) => getUserInvesteeId(state));
    const [isResendOtp, setIsResendOtp] = useState(false);
    const userId = storage.get('user_id');
    const [isEditing, setIsEditing] = useState(false);
    const [whatsappConfirmation, setWhatsappConfirmation] = useState(true);
    const phoneNo = useSelector((state) => getPhoneNumber(state)) ?? state?.mobileNumber ?? '';
    const [phoneNumber, setPhoneNumber] = useState(phoneNo);
    const countryCode = useSelector((state) => getCountryCode(state));
    const navigate = useNavigate();
    const isInvestee = useSelector((state) => getIfUserIsInvestee(state));
    const [timeLeft, setTimeLeft] = useState(30);
    const sidebarConfig = useSelector(getInvesteeSidebarConfigTab);
    const widget = useSelector(getWidgetData);

    const dispatch = useDispatch();
    useEffect(() => {
        if (isEmpty(phoneNo)) {
            setPhoneVerified(false);
        }
    });
    useEffect(() => {
        if (isNil(emailId) || isNil(isEmailVerified) || isNil(userId)) {
            navigate('/');
        }
        if (isInvestee && !isEmpty(phoneNo) && sidebarConfig && widget) {
            navigate(basePathInvestee(sidebarConfig, widget));
        }
    }, [sidebarConfig, widget]);
    const fetchUser = async (isPhoneVerified: boolean) => {
        const UserRes: any = await dispatch(
            fetchUserProfile(userId, false, false, isPhoneVerified),
        );
        if (UserRes?.resStatus === API_STATUS.SUCCESS) {
            navigate(basePathInvestee(sidebarConfig, widget));
        }
    };
    const proceedFunctionality = async () => {
        const payload: WhatsappPreference = {
            email: emailId,
            phone: phoneNumber,
            prefMap: {
                WHATSAPP: whatsappConfirmation,
            },
        };
        validateOtp(phoneNumber, otps).then(async (res: any) => {
            if (res?.status) {
                const Whatsappres = await setWhatsappPreference(payload);
                if (Whatsappres) {
                    showNotification(Whatsappres.status, Whatsappres.message);
                    fetchUser(res?.phoneVerified);
                } else {
                    showNotification(SHOW_NOTIFICATION_STATUS.ERROR, 'Something went wrong');
                }
            } else {
                showNotification(SHOW_NOTIFICATION_STATUS.ERROR, 'Something went wrong');
            }
        });
    };
    useEffect(() => {
        const timer: any = setInterval(() => countdown(timer), 1000);
        return () => {
            clearInterval(timer);
        };
    });
    const countdown = (timer: any) => {
        let time = timeLeft - 1;
        if (isOtpSent) {
            setTimeLeft(time);
            if (timeLeft < 1) {
                setTimeLeft(30);
            }
            if (timeLeft === 1) {
                setIsOtpSent(false);
                clearInterval(timer);
            }
        }
    };
    const sendOtp = async () => {
        if (isEmailVerified) {
            let payload: any = {
                user: {
                    mobileNumber: phoneNumber,
                    userType: 'Investee',
                    medium: 'SMS',
                },
                requestId: generateRequestId(),
            };
            const res = await sendOtpHelper(payload);
            if (res) {
                if (res.responseData) {
                    setIsResendOtp(true);
                    setIsOtpSent(true);
                    showNotification(
                        SHOW_NOTIFICATION_STATUS.SUCCESS,
                        res.responseData.responseMessage,
                    );
                } else {
                    setIsResendOtp(false);
                    showNotification(SHOW_NOTIFICATION_STATUS.ERROR, res);
                }
            }
        } else {
            showNotification(SHOW_NOTIFICATION_STATUS.ERROR, 'Please verify your email first');
        }
    };
    const validateOtp = async (phoneNumber: string, otps: any) => {
        const payload = {
            requestId: generateRequestId(),
            user: {
                mobileNumber: phoneNumber,
                otp: otps.otp1 + otps.otp2 + otps.otp3 + otps.otp4 + otps.otp5 + otps.otp6,
                userType: 'Investee',
                medium: 'SMS',
            },
        };
        const res = await validateOtpHelper(payload);
        if (res) {
            if (res.responseData) {
                setPhoneVerified(res.user.phoneVerified);
                setIsEmailVerified(res.user.emailVerified);
                showNotification(
                    SHOW_NOTIFICATION_STATUS.SUCCESS,
                    res.responseData.responseMessage,
                );
                return { status: true, phoneVerified: res?.user?.phoneVerified };
            } else {
                showNotification(SHOW_NOTIFICATION_STATUS.ERROR, res);
                return { status: false, phoneVerified: null };
            }
        }
    };
    const updatePhoneNo = async (phoneNumber: string, emailId: string) => {
        const payload = {
            contact_email: emailId,
            phone_number: phoneNumber,
        };
        const res: any = await dispatch(updateInvestProfileInfo(investeeId, payload, true));
        if (res?.status === API_STATUS.SUCCESS) {
            setPhoneNumber(res.data.user.phone_number);
            setPhoneVerified(res.data.user.is_phone_verified);
            showNotification('Success', 'Phone Number Successfully Updated');
            return true;
        } else {
            setPhoneNumber(phoneNo);
            showNotification(SHOW_NOTIFICATION_STATUS.ERROR, res.data.message);
            return false;
        }
    };
    const handleWhatsappConfirmation = () => {
        setWhatsappConfirmation(!whatsappConfirmation);
    };
    useEffect(() => {
        if (
            isEmailVerified &&
            otps.otp1 &&
            otps.otp2 &&
            otps.otp3 &&
            otps.otp4 &&
            otps.otp5 &&
            otps.otp6
        ) {
            setIsDisabled(false);
        }
    }, [otps, isEmailVerified]);
    const handleEditBtnClick = () => {
        if (isEmailVerified) {
            setPhoneNumber('');
            setPhoneVerified(false);
            setIsEditing(true);
        } else {
            showNotification(SHOW_NOTIFICATION_STATUS.ERROR, 'Please verify your email first');
        }
    };
    const handleNumberSave = () => {
        if (phoneNumber?.length === 10) {
            if (phoneNumber !== phoneNo) {
                updatePhoneNo(phoneNumber, emailId).then(() => {
                    setIsResendOtp(false);
                    setIsEditing(false);
                });
            } else {
                setIsResendOtp(false);
                setIsEditing(false);
            }
        } else {
            showNotification(SHOW_NOTIFICATION_STATUS.ERROR, 'Please enter valid phone number');
        }
    };
    return (
        <>
            <div
                className="col d-flex justify-content-center align-items-center loginForm"
                style={{ background: 'white' }}
            >
                <div id="inner-wrapper" className="text-center" style={{ width: '75%' }}>
                    <div className="imgContainer">
                        <img src="./assets/verifyEmailSign.svg" alt="verifyEmailSign" />
                    </div>
                    <div className="headTextContainer">Please verify your details</div>
                    <div className="subtextContainer">
                        1. We’ve send link on <span className="ffgb r-ml-2">{emailId}</span>
                    </div>
                    <div className="dflex r-mt-4">
                        <div className="dflex r-mt-2">
                            {isEmailVerified ? (
                                <img
                                    src="./assets/Done.svg"
                                    alt="infoIcon"
                                    width="14px"
                                    height="14px"
                                />
                            ) : (
                                <img
                                    src="./assets/pending.svg"
                                    alt="infoIcon"
                                    width="14px"
                                    height="14px"
                                />
                            )}
                            {isEmailVerified ? (
                                <span className="verified">Verified</span>
                            ) : (
                                <span className="pending">Not Verified</span>
                            )}
                        </div>
                        {!isEmailVerified && (
                            <button
                                className="resendBtn"
                                onClick={() => dispatch(resendVerifyUserEmail(userId))}
                            >
                                Resend Verification Email
                            </button>
                        )}
                    </div>
                    {/* <div>
                        <div className="subtextContainer">
                            {!isEditing ? (
                                <>
                                    2. We will send an OTP on{' '}
                                    <span className="ffgb r-ml-2">
                                        +{countryCode ?? '91'} {phoneNumber ?? '-'}
                                    </span>{' '}
                                    {!phoneVerified && (
                                        <span className="editIcon">
                                            <img
                                                onClick={() => {
                                                    handleEditBtnClick();
                                                }}
                                                src="./assets/editPhonePencil.svg"
                                                alt="infoIcon"
                                                width="10px"
                                                height="10px"
                                            />
                                        </span>
                                    )}
                                </>
                            ) : (
                                <>2. Update your contact number</>
                            )}
                        </div>
                        <div className="dflex r-mt-4">
                            <div className="dflex r-mt-2">
                                {phoneVerified ? (
                                    <img
                                        src="./assets/Done.svg"
                                        alt="infoIcon"
                                        width="14px"
                                        height="14px"
                                    />
                                ) : (
                                    <img
                                        src="./assets/pending.svg"
                                        alt="infoIcon"
                                        width="14px"
                                        height="14px"
                                    />
                                )}
                                {phoneVerified ? (
                                    <span className="verified">Verified</span>
                                ) : (
                                    <span className="pending">Not Verified</span>
                                )}
                            </div>
                            {isEditing && (
                                <button
                                    className="resendBtn"
                                    onClick={() => {
                                        handleNumberSave();
                                    }}
                                >
                                    Save
                                </button>
                            )}
                            {!phoneVerified && !isEditing && (
                                <button
                                    disabled={isOtpSent}
                                    className="resendBtn"
                                    onClick={() => sendOtp()}
                                >
                                    {isResendOtp ? 'Resend OTP' : 'Send OTP'}
                                </button>
                            )}
                        </div>
                        {isOtpSent && !isEditing && (
                            <div
                                style={{
                                    color: 'red',
                                    fontSize: '8px',
                                    float: 'right',
                                    marginRight: '15px',
                                }}
                            >
                                {timeLeft} Seconds
                            </div>
                        )}
                        {!isEditing ? (
                            <OtpInput
                                isResendOtp={isResendOtp}
                                phoneVerified={phoneVerified}
                                setOtps={setOtps}
                            />
                        ) : (
                            <PhoneNumberInput
                                phoneNumber={phoneNumber}
                                setPhoneNumber={setPhoneNumber}
                            />
                        )}
                        {!isEditing && (
                            <div className="whatsappContainer">
                                <input
                                    checked={whatsappConfirmation}
                                    onChange={() => {
                                        handleWhatsappConfirmation();
                                    }}
                                    type={'checkbox'}
                                    id="whatsappConfirmation"
                                ></input>
                                <label className="whatsapplabel" htmlFor="whatsappConfirmation">
                                    Opt-in for Whatsapp communication.
                                </label>
                            </div>
                        )}
                    </div> */}
                    {/* <button
                        disabled={isdisabled}
                        onClick={() => {
                            proceedFunctionality();
                        }}
                        className="ProceedBtn"
                    >
                        Proceed
                    </button> */}
                </div>
            </div>
        </>
    );
}

export default VerifyEmailPhone;
